<template>
    <el-row :gutter="20">
        <el-col :md="24" :sm="24" class="mb-3">
            <el-card class="profile" shadow="never">
                <div slot="header" class="">#{{single.id}}){{single.subject}}</div>
                <div class="">
                    <div v-for="x in single.items" :key="x.id">
                        <b>问题: {{x.order}}){{x.question}}</b>
                        <div v-if="x.answer_type==1" class="px-3">
                            <div v-for="a in toArray(x.answers)" :key="a">
                                <label><input type="checkbox" :name="'question_'+x.id"/> {{a}}</label>
                            </div>
                        </div>
                        <div v-else class="p-5">
                            <div v-for="a in toArray(x.answers)" :key="a">
                                <label>
                                <input type="radio" :name="'question_'+x.id"/> {{a}}</label>
                            </div>
                        </div>
                        <div class="mb-3"></div>
                    </div>
                </div>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "poll-view",
        data() {
            return {
                single: {}
            }
        },
        computed: {
            ...mapState(['user', 'process', 'preset']),

        },
        mounted() {
            this.$api('Admin.Poll.Get', {id: this.$route.params.id}, true).then(res => {
                this.single = res.data.data;
            });
        },
        methods: {
            toArray(str) {
                console.log(typeof str);
                const s = str.replaceAll('，', ',');
                return s.split(',');
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
